import styled, { css } from "styled-components";

import colors from "core/colors";
import breakpoints from "core/breakpoints";

import { convertPxToRem } from "frontend/components/helpers";

const BANNER_HEIGHT_PX = 50;
const BANNER_HEIGHT_REM = convertPxToRem({ px: BANNER_HEIGHT_PX });

const CLOSE_ICON_SIZE_PX = 20;
const CLOSE_ICON_SIZE_REM = convertPxToRem({ px: CLOSE_ICON_SIZE_PX });
const CLOSE_ICON_TOP_PX = (BANNER_HEIGHT_PX - CLOSE_ICON_SIZE_PX) / 2;
const CLOSE_ICON_TOP_REM = convertPxToRem({ px: CLOSE_ICON_TOP_PX });

const BANNER_CONTENT_RIGHT_PX = 20;
const BANNER_CONTENT_RIGHT_REM = convertPxToRem({
    px: BANNER_CONTENT_RIGHT_PX
});

export const BannerContent = styled.div`
    flex-basis: calc(
        100% - ${BANNER_CONTENT_RIGHT_REM} - ${CLOSE_ICON_SIZE_REM}
    );
    width: calc(100% - ${BANNER_CONTENT_RIGHT_REM} - ${CLOSE_ICON_SIZE_REM});
    text-decoration: none;
`;

export const BannerInnerContainer = styled.div`
    padding: ${convertPxToRem({ px: 8 })} 0;
    min-height: ${BANNER_HEIGHT_REM};
    display: flex;
    align-items: center;
    justify-content: center;

    // mobile:
    @media (max-width: ${breakpoints.beforeTablet.rem}) {
        padding-left: ${convertPxToRem({ px: 15 })};
    }
`;

export const PseudoLink = styled.span`
    ${({ href }) =>
        !!href &&
        css`
            text-decoration: underline;
        `}
`;

export const BannerContainer = styled.section`
    position: fixed;
    z-index: 999;
    transition: all 0.3s ease;
    text-align: center;
    overflow: hidden;
    width: 100%;
    font-size: ${convertPxToRem({ px: 14 })};
    line-height: ${convertPxToRem({ px: 20 })};

    ${({ type }) => css`
        ${type === "downtime" &&
            css`
                background-color: #81b5e7;
                color: ${colors.secondary.orca};
            `}

        ${type === "privacy" &&
            css`
                background-color: #81b5e7;
                color: ${colors.secondary.orca};

                //force spacing for anchor tags not allowing space:
                a {
                    margin: 0 ${convertPxToRem({ px: 5 })};
                }

                @media (max-width: ${breakpoints.beforeTablet.rem}) {
                    ${BannerInnerContainer} {
                        display: block;
                    }
                }
            `}

        ${type === "promotional" &&
            css`
                background-color: ${colors.alternative.darkMode.pistachio};
                color: ${colors.secondary.orca};

                //force spacing for anchor tags not allowing space:
                a {
                    margin: 0 ${convertPxToRem({ px: 5 })};
                }
            `}
    `}

    a, a:visited {
        color: ${colors.secondary.orca};
    }

    //apply necessary margin for size of banner to top of page:
    + section#site-header {
        margin-top: ${BANNER_HEIGHT_REM};
    }
`;

//Todo in future PR: make this a button instead of span re: a11y concerns
export const DismissContainer = styled.span`
    cursor: pointer;
    display: block;
    position: absolute;
    right: ${convertPxToRem({ px: 24 })};
    top: ${CLOSE_ICON_TOP_REM};
    text-decoration: none;

    // tablet:
    @media (max-width: ${breakpoints.beforeDesktop.rem}) {
        right: ${convertPxToRem({ px: 20 })};
    }
    // mobile:
    @media (max-width: ${breakpoints.beforeTablet.rem}) {
        right: ${convertPxToRem({ px: 15 })};
    }
`;
